<template>
  <v-app>
    <v-fade-transition>
      <router-view />
    </v-fade-transition>

    <TheSnackbar />

    <TheDialog />
  </v-app>
</template>

<script>
import TheSnackbar from '@/components/TheSnackbar.vue';
import TheDialog from '@/components/Dialog/TheDialog.vue';

export default {
  components: {
    TheSnackbar,
    TheDialog,
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: local("Poppins"),
   url(./assets/fonts/Poppins/Poppins-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  src: local("Poppins"),
   url(./assets/fonts/Poppins/Poppins-Medium.ttf) format("truetype");
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  src: local("Poppins"),
   url(./assets/fonts/Poppins/Poppins-Bold.ttf) format("truetype");
}
@import '/src/assets/styles/index.scss';
</style>
